import axios from "axios";
const baseUrl = process.env.REACT_APP_BASE_URL + "/public";

export async function Authen(token) {
  try {
    const response = await axios.post(baseUrl + "/authen", {token});
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function GetPackageDetailByTracking(tracking, masked = false) {
  try {
    const response = await axios.get(baseUrl + "/package-detail", {
      params: {
        tracking: tracking,
        ...(masked && { masked: 'true' }),
      },
    });
    
    // Handle new backend response format
    if (response.status === 200 && response.data.success) {
      return {
        status: 200,
        data: response.data.data
      };
    } else if (response.status === 404 || !response.data.success) {
      return {
        status: 204, // Maintain backward compatibility - public frontend expects 204 for not found
        message: response.data.message || "Package not found"
      };
    }
    
    return response;
  } catch (error) {
    console.error(error);
    
    // Handle error responses
    if (error.response?.status === 404) {
      return {
        status: 204, // Maintain backward compatibility - public frontend expects 204 for not found
        message: error.response.data?.message || "Package not found"
      };
    } else if (error.response?.status === 400) {
      return {
        status: 400,
        message: error.response.data?.message || "Bad request"
      };
    }
    
    throw error;
  }
}

export async function GetTrackingLog(tracking) {
  try {
    const response = await axios.get(baseUrl + "/trackinglog", {
      params: {
        tracking: tracking,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function GetRouteDetail(routeId) {
  try {
    const response = await axios.get(baseUrl + "/route-detail", {
      params: {
        id: routeId,
      },
    });
    
    // Handle new backend response format
    if (response.status === 200 && response.data.success) {
      return {
        status: 200,
        data: response.data.data
      };
    } else if (response.status === 404 || !response.data.success) {
      return {
        status: 404,
        message: response.data.message || "Route not found"
      };
    }
    
    return response;
  } catch (error) {
    console.error("GetRouteDetail error:", error);
    
    // Handle error responses
    if (error.response?.status === 404) {
      return {
        status: 404,
        message: error.response.data?.message || "Route not found"
      };
    } else if (error.response?.status === 400) {
      return {
        status: 400,
        message: error.response.data?.message || "Invalid route ID"
      };
    }
    
    throw error;
  }
}